import { render, staticRenderFns } from "./RetainStatiscal.vue?vue&type=template&id=5d0990e4&scoped=true&"
import script from "./RetainStatiscal.vue?vue&type=script&lang=js&"
export * from "./RetainStatiscal.vue?vue&type=script&lang=js&"
import style0 from "./RetainStatiscal.vue?vue&type=style&index=0&id=5d0990e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0990e4",
  null
  
)

export default component.exports